// src/API/Address/GetNearbyPinCodesPamCodeAsync.ts

import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export interface PinCodeData {
    pinCode: string;
    blockCode: string;
    pamCode:string;
  }
  
  /**
   * @param latitude - The latitude coordinate.
   * @param longitude - The longitude coordinate.
   * @param token - The authentication token.
   * @returns A promise that resolves to an array of pin code data.
   */
  export async function getNearbyPinCodesPamCodeAsync(
    latitude: number,
    longitude: number,
    token: string,
    t: (key: string) => string
  ): Promise<PinCodeData[] | null> {

    if (!navigator.onLine) {
      toast.error(t("internetConnection"), { toastId: "offline-error" });      return null;
    }
  
    try {
      const baseUrl = getApiBaseUrl();
      const response = await fetch(
        `${baseUrl}/api/Address/GetNearbyPinCodesPamCodeAsync?latitude=${latitude}&longitude=${longitude}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
  
      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
  
      const data: string[] = await response.json();
      const formattedPinCodes: PinCodeData[] = data.map((item: string) => ({
        pinCode: item.slice(0, 6),
        blockCode: item.slice(6),
        pamCode:item
      }));
  
      return formattedPinCodes;
    } catch (error) {
      // console.error('Error fetching pin codes:', error);
      throw error;
    }
  }
  